import cx from 'classnames'
import {ReactNode} from 'react'

type Props = {
  image: ReactNode
  header: ReactNode
  main: ReactNode
  className?: string
}

export const Card = ({image, header, main, className}: Props) => {
  return (
    <div className={cx('w-full @container', className)}>
      <div className="block @[407px]:hidden w-full">
        <div className="p-4 flex flex-col gap-4 w-full">
          <div className="flex gap-4 w-full">
            {image}
            {header}
          </div>
          {main}
        </div>
      </div>

      <div className="@[407px]:block hidden w-full">
        <div className="p-4 flex gap-4 w-full">
          {image}
          <div className="flex flex-col gap-4 w-full">
            {header}
            {main}
          </div>
        </div>
      </div>
    </div>
  )
}
